import { Link } from 'react-router-dom';

import styled from 'styled-components';

import colors from '~/styles/colors';
import grid from '~/styles/grid';

export const Container = styled.div`
  position: absolute;
  display: inline-block;
  margin-left: ${grid['5xl']};
  min-width: 196px;
  transform: translate(-100%, 32px);
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.22);
  border: solid 1px #e6e6e6;
  background-color: #ffffff;
  border-radius: 5px;
  z-index: 100;

  &:before {
    content: '';
    display: block;
    position: absolute;
    right: 14px;
    bottom: 100%;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-bottom-color: #e6e6e6;
  }

  &:after {
    content: '';
    display: block;
    position: absolute;
    right: 1.071rem;
    top: -1.214rem;
    bottom: 100%;
    width: 0;
    height: 0;
    border: 9px solid transparent;
    border-bottom-color: white;
  }
`;

export const UserContent = styled.div`
  padding: ${grid.md};
  display: flex;
  align-items: center;
`;

export const StyledMenuUser = styled.div`
  margin-left: 1.143rem;
`;

export const StyledMenuName = styled.span`
  display: block;
  font-size: 16px;
`;

export const StyledMenuEmail = styled.span`
  display: block;
  font-size: 12px;
  color: #999999;
`;

export const StyledMenu = styled.div`
  border-top: solid 2px #b3b3b3;
  padding: ${grid.md} 0;
  background: #f2f2f2;

  &:hover {
    cursor: pointer;
  }
`;

export const ProfileOption = styled(Link)`
  display: block;
  padding: ${grid.sm} 0;
  font-size: 14px;
  color: ${colors.primary};

  &:hover {
    cursor: pointer;
    color: #aa0532;
  }
`;

export const PasswordOption = styled.p`
  display: block;
  padding: ${grid.sm} 0;
  font-size: 14px;
  color: ${colors.primary};
  background: transparent;
  border: none;
  margin: 0;

  &:hover {
    cursor: pointer;
    color: #aa0532;
  }
`;

export const SignOutOption = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: inherit;
`;

export const ExitSpan = styled.span`
  color: ${colors.primary};
  font-weight: 600;
`;

export const EditPasswordBox = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: none;
  padding: ${grid.sm} ${grid.lg};
  background: transparent;
  width: 100%;
  border-top: 2px solid #b3b3b3;
`;
